<template>
  <div class="fixed top-0 bottom-0 left-0 right-0 z-[2000] px-3 py-2 bg-white overflow-y-scroll">
    <div class="flex items-center justify-end mb-4">
      <button class="flex flex-col items-center justify-center pt-2" type="button" @click="closeLoginMenu" @keydown.esc="closeMenu" data-testid="mobileMenuCloseLoginMenuButton">
        <img width="18" height="18" class="inline top-mobile-icons" src="../../../assets/images/cross-black.svg" alt="close menu" />
        <span class="whitespace-nowrap text-black leading-4 mt-0.5 uppercase font-futuraEfDemiBold text-[0.6875rem]">{{ translations?.topMenuMobile.closeMenu }}</span>
      </button>
      <!--
      <button class="p-2 focus:outline-black-alt-tight" @click="closeLoginMenu">
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" class="inline-block" width="26px" height="26px" viewBox="0 0 20 20">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10 8.182L18.182 0 20 1.818 1.818 20 0 18.182 8.182 10 0 1.818 1.818 0 10 8.182zM18.182 20l-6.73-6.73 1.819-1.817L20 18.182 18.182 20z" fill="#000" />
        </svg>
      </button>
      -->
    </div>
    <div class="flex flex-col items-center mb-7">
      <div class="flex items-center justify-center w-[5.5rem] h-[5.5rem] rounded-full bg-green-dark mb-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" fill="none" viewBox="0 0 16 16" class="absolute w-[2.8rem] h-[2.8rem]" data-testid="mobileMenuLoginIcon">
          <path fill="#FFF" d="M1.57 15.2c.897-1.872 3.44-3.168 6.43-3.168 2.99 0 5.533 1.368 6.43 3.168H16c-.897-2.664-4.112-4.608-8-4.608S.897 12.536 0 15.2h1.57Z" />
          <path
            fill="#FFF"
            d="M7.776.8C4.86.8 2.542 3.032 2.542 5.84c0 2.232 1.57 4.176 3.664 4.824l.448-1.368c-1.495-.432-2.617-1.8-2.617-3.456 0-2.016 1.645-3.6 3.739-3.6 2.093 0 3.738 1.584 3.738 3.6 0 1.584-1.047 2.88-2.467 3.384l.523 1.368c2.019-.72 3.44-2.592 3.44-4.752C13.01 3.032 10.616.8 7.775.8Z" />
        </svg>
      </div>
      <h3 class="inline-block mb-2 text-4xl" data-testid="mobileMenuLoginHeading">
        {{ login?.heading }}
      </h3>
      <p class="text-lg leading-6 text-center" data-testid="mobileMenuLoginParagraph">{{ login?.description }}</p>
      <div v-if="login?.areas?.length > 0" class="w-full mt-6 mobile-maxwidth">
        <div v-for="(area, index) in login?.areas" :key="area.id" class="w-full mobile-maxwidth">
          <h4 class="text-xl normal-case" :data-testid="`mobileMenuLoginSubHeading-${index}`">
            {{ area.heading }}
          </h4>
          <ul v-if="area.links?.length > 0" class="mb-5">
            <li v-for="(link, subindex) in area.links" :key="`${index}-${subindex}`" class="mt-1">
              <a :href="link.url" class="arrow-link-forward" :data-testid="`mobileMenuLoginSubLink-${index}-${subindex}`">{{ link.text }}</a>
            </li>
          </ul>
        </div>
      </div>
      <!-- Logout button -->
      <a v-if="login?.userName" :href="login?.logOutButton?.url" class="w-full mt-8 btn-secondary btn-icon-user mobile-maxwidth">{{ login?.logOutButton?.text }}</a>
    </div>

    <ellevio-web-log-out-button :login="login" :my-pages="myPages" :user-logged-in="userLoggedIn" />
  </div>
</template>

<script>
import EllevioWebLogOutButton from './LogOutButton.vue'
export default {
  name: 'EllevioWebMobileLoginArea',
  components: {
    EllevioWebLogOutButton
  },
  props: {
    login: {
      type: Object,
      default: () => {}
    },
    myPages: {
      type: Boolean,
      default: false
    },
    userLoggedIn: {
      type: Boolean,
      default: false
    },
    translations: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    closeLoginMenu() {
      this.$emit('close-login-menu')
    }
  }
}
</script>
<style>
.mobile-maxwidth {
  max-width: 400px;
}
</style>
